module.exports = "/assets/data/514c6903d2da3f20f734887da8db1479-CO7.data.json";